__turbopack_context__.v({
  "cards": "siWOsq_cards",
  "container": "siWOsq_container",
  "containerCard": "siWOsq_containerCard",
  "h3Platform": "siWOsq_h3Platform",
  "image": "siWOsq_image",
  "imageContainer": "siWOsq_imageContainer",
  "pPlatform": "siWOsq_pPlatform",
  "paragraph": "siWOsq_paragraph",
  "rowEtc": "siWOsq_rowEtc",
  "textCategory": "siWOsq_textCategory",
  "textH2": "siWOsq_textH2",
  "title": "siWOsq_title",
});
